export default function mapApiUrl(relativeUrl) {
    let urlMask = "/api/identity/"
    let baseUrl = "https://" + window.location.hostname
    if (relativeUrl.startsWith(urlMask)) {
        // return "http://rigid-dev.rigsis.com:8081/identity-management/api/" + relativeUrl.slice(urlMask.length)
        return baseUrl + ":8084/identity-management/api/" + relativeUrl.slice(urlMask.length)
        // return "http://localhost:8081/identity-management/api/" + relativeUrl.slice(urlMask.length)
    }
    urlMask = "/api/well/"
    if (relativeUrl.startsWith(urlMask)) {
        // return "http://rigid-dev.rigsis.com:8764/well-management/api/" + relativeUrl.slice(urlMask.length)
        return baseUrl + ":8085/well-management/api/" + relativeUrl.slice(urlMask.length)
        // return "http://localhost:8087/well-management/api/" + relativeUrl.slice(urlMask.length)
    }
    urlMask = "/api/form/"
    if (relativeUrl.startsWith(urlMask)) {
        // return "http://rigid-dev.rigsis.com:8765/form-management/api/" + relativeUrl.slice(urlMask.length)
        return baseUrl + ":8086/form-management/api/" + relativeUrl.slice(urlMask.length)
        // return "http://localhost:8083/form-management/api/" + relativeUrl.slice(urlMask.length)
    }
    urlMask = "/api/"
    if (relativeUrl.startsWith(urlMask)) {
        // return "http://rigid-dev.rigsis.com:8081/identity-management/api/" + relativeUrl.slice(urlMask.length)
        return baseUrl + ":8084/identity-management/api/" + relativeUrl.slice(urlMask.length)
        // return "http://localhost:8081/identity-management/api/" + relativeUrl.slice(urlMask.length)
    }
}